export default __webpack_public_path__ + "static/media/pay-it-forward.fe7eda2a.svg";